const FOOTER_LINKS = [
  { label: "下载方式", href: "#methods" },
  { label: "教程步骤", href: "#tutorial" },
  { label: "工具推荐", href: "#tools" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
  { label: "联系我们", href: "#contact" },
];

const DOWNLOAD_LINKS = [
  "本子网站打包下载",
  "本子网站批量下载",
  "本子网站离线下载",
  "本子网站资源下载",
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-950 text-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-display text-xl text-background-50">漫藏手册</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300/80 max-w-xs">
              专注整理本子网站打包下载、批量下载与离线下载的实操指南，
              让每个想收藏资源的人都能安稳把内容留在本地。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">站内导航</h4>
            <ul className="grid grid-cols-2 gap-2.5">
              {FOOTER_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="inline-flex items-center gap-1.5 text-sm text-background-300/80 hover:text-background-50 transition-colors"
                  >
                    <i className="ri-arrow-right-s-line text-accent-400"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">下载相关</h4>
            <ul className="grid grid-cols-2 gap-2.5">
              {DOWNLOAD_LINKS.map((l) => (
                <li key={l}>
                  <a
                    href="#methods"
                    className="inline-flex items-center gap-1.5 text-sm text-background-300/80 hover:text-background-50 transition-colors"
                  >
                    <i className="ri-download-2-line text-accent-400"></i>
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 漫藏手册 · 本子网站下载方式指南
          </p>
          <p className="text-xs text-background-400">
            本站仅分享下载方法与整理技巧，尊重原作者版权，不提供任何资源本身。
          </p>
        </div>
      </div>
    </footer>
  );
}